import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { useParams, useLocation } from "react-router-dom";

const BASE_URL = "http://nissi-india.com";

const ContractorPaymentDetailsReport = () => {
  const { payId: payIdParam } = useParams(); // /contractor-payment-print/:payId
  const location = useLocation();

  const query = useMemo(() => new URLSearchParams(location.search), [location.search]);

  // payid from route OR query
  const payid =
    Number(payIdParam || 0) ||
    Number(query.get("payid") || query.get("payId") || 0) ||
    0;

  // branchid from localstorage OR query
 const branchid = Number(localStorage.getItem("branchId") || 0);

  const [row, setRow] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const formatMoney = (v) => {
    const n = Number(v);
    return Number.isFinite(n)
      ? n.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      : "0.00";
  };

  const fetchReportData = async () => {
    if (!branchid) {
      setError("branchid missing (localStorage.branchId or query ?branchid= )");
      return;
    }
    if (!payid) {
      setError("payid missing in URL. Use /contractor-payment-print/:payId");
      return;
    }

    try {
      setLoading(true);
      setError("");

      const res = await axios.get(`${BASE_URL}/api/contractorReport/printOne`, {
        params: { branchid, payid },
      });

      if (!res.data?.success) {
        setError(res.data?.message || "Failed to load print data");
        setRow(null);
        return;
      }

      setRow(res.data.row || null);

      // ✅ optional auto print
      setTimeout(() => {
        window.print();
      }, 400);
    } catch (err) {
      console.error(err);
      setError(err?.response?.data?.message || "Server error while loading print data");
      setRow(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReportData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [payid, branchid]);

  return (
    <div className="max-w-full mx-auto p-4 bg-white font-sans text-xs print:p-0 print:max-w-none">
      {/* Header Section */}
      <div className="border-2 border-black mb-0">
        <div className="text-center py-3 border-b border-black">
          <h1 className="text-lg font-bold text-red-600">Nissi Infotech</h1>
          <div className="text-sm">Nissi</div>
          <div className="text-sm font-bold">CIVIL CONSTRUCTION</div>
          <div className="text-xs">
            3/42-12, Nagappa colony, kavundampalayam--641030, Tamil Nadu,India
          </div>
          <div className="text-xs">
            Phone No : 9003744644 Email : infraconsoft-implementation@nissiinfotech.in
          </div>
        </div>

        <div className="text-center py-2 border-b border-black font-bold">
          CONTRACTOR PAYMENT DETAILS REPORT
        </div>
      </div>

      {/* Loading/Error */}
      {loading && (
        <div className="text-center py-4">
          <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-black"></div>
          <div className="mt-2">Loading report data...</div>
        </div>
      )}

      {error && !loading && (
        <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded mb-4">
          <div className="font-bold">Error loading report:</div>
          <div className="mt-1">{error}</div>
          <div className="mt-2 text-xs text-gray-700">
            Debug: branchid={branchid || "-"} | payid={payid || "-"}
          </div>
          <button
            onClick={fetchReportData}
            className="mt-3 bg-red-600 text-white px-3 py-1 rounded text-xs hover:bg-red-700"
          >
            Retry
          </button>
        </div>
      )}

      {/* Report Details */}
      {!loading && row && (
        <div className="border-l-2 border-r-2 border-black">
          <div className="p-4 border-b border-black">
            <div className="grid grid-cols-2 gap-4 text-sm">
              <div>
                <strong>Date :</strong> {row.fld_date || "-"}
              </div>
              <div>
                <strong>Branch :</strong> {branchid}
              </div>
              <div>
                <strong>Bill No :</strong> {row.fld_billno || "-"}
              </div>
              <div>
                <strong>Work Name:</strong> {row.fld_projectname || "-"}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Table */}
      <div className="border-l-2 border-r-2 border-b-2 border-black">
        <table className="w-full text-xs">
          <thead>
            <tr className="border-b border-black">
              <th className="border-r border-black px-2 py-2 w-12">Sno</th>
              <th className="border-r border-black px-2 py-2 w-32">Contractor Name</th>
              <th className="border-r border-black px-2 py-2 w-40">Project Name</th>
              <th className="border-r border-black px-2 py-2 w-20">Amount</th>
              <th className="border-r border-black px-2 py-2 w-20">Bal Amount</th>
            </tr>
          </thead>
          <tbody>
            {!row ? (
              <tr>
                <td colSpan="5" className="p-4 text-center text-gray-500 border-r border-black">
                  No data available
                </td>
              </tr>
            ) : (
              <tr className="border-b border-gray-300">
                <td className="border-r border-black px-2 py-2 text-center">1</td>
                <td className="border-r border-black px-2 py-2">
                  {row.fld_contractorname || "-"}
                </td>
                <td className="border-r border-black px-2 py-2">
                  {row.fld_projectname || "-"}
                </td>
                <td className="border-r border-black px-2 py-2 text-right">
                  {formatMoney(row.fld_paidamount)}
                </td>
                <td className="border-r border-black px-2 py-2 text-right">
                  {formatMoney(row.fld_balamount)}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Page Number */}
      <div className="text-right mt-2 text-xs">1</div>

      {/* Footer */}
      <div className="mt-4 text-xs text-gray-600 border-t border-gray-300 pt-2">
        <div className="underline">
          Report generated by ERP-Software - www.infraconsoft.com owned by www.nissiinfotech.com
        </div>
      </div>

      {/* Print Styles */}
      <style>{`
        @media print {
          body { margin: 0; }
          .print\\:hidden { display: none !important; }
          .print\\:p-0 { padding: 0 !important; }
          .print\\:max-w-none { max-width: none !important; }
          * { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
        }
      `}</style>
    </div>
  );
};

export default ContractorPaymentDetailsReport;
